export default __webpack_public_path__ + "static/community_card_hover-12f114538489f3447d01b8859be1f0f8.png";